import { Box, Card } from "@chakra-ui/react";
import CompanyHeader from "components/ui/CompanyHeader";

interface CompanyListProps {
  contentGroup: any;
  list: any;
}

export default function CompanyList({ contentGroup, list }: CompanyListProps) {
  return (
    <Card
      pos="fixed"
      bottom="90px"
      left="50%"
      transform="translateX(-50%)"
      p="15px"
      borderRadius="full"
    >
      <Box mr="30px">
        <CompanyHeader
          company={list.company}
          description={`${contentGroup.name} - ${list.name}`}
        />
      </Box>
    </Card>
  );
}
